import styled from 'styled-components';

export const PagamentosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .searchBarContainer {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  .content-test {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 500px;

    h1 {
      font-size: 3rem;
      text-align: center;
    }
  }
`;

export const Row = styled.tr`
  td {
    &:last-child {
      font-size: 24px;
    }
  }
`;
